import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Prof_Dr_Virendra_Kumar_Paul_Director from '../../Assets/Images/TeamMemberProfile/Prof. Dr. Virendra Kumar Paul Director.jpg'

import './ADirectorDesk.css'

const ADirectorDesk = () => {

    return (
        <section>

            <div className='row'>
                {/* Left Menu */}
                <div className="col-md-3 text-black">
                    <img src={Prof_Dr_Virendra_Kumar_Paul_Director} className="card-img-top director-img" alt="Dean" />
                    <h6 className='text-black mt-4'>Prof. Dr. Virendra Kumar Paul</h6>
                    {/* <h6 className='text-black mt-4'> */}
                    Director, School of Planning and Architecture, New Delhi
                    {/* </h6> */}
                    {/* <p className='text-black mt-4'>PH.D., D.LITT. (h.c.), B.Arch., M.B.E.M., FIIA, FIE, C. Eng. FRICS, FIHE, Hon. FIFE(I)</p> */}
                </div>

                {/* Right Content */}
                <div className="col-md-9">
                    <h5 className="text-black fw-bold">Message from the Director's Desk</h5>
                    <p className='text-black'>Greetings from CoE SPA New Delhi</p>
                    <p className='text-black'>It gives me great pleasure to announce the launch of the dedicated website of the Centre of Excellence (CoE) in Urban Planning and Design at SPA Delhi. This marks a significant step forward in our ongoing commitment to advance urban planning, architecture, building engineering, and design through real-world engagement, research, and capacity-building.</p>
                    <p className='text-black'>Recognized by the Ministry of Housing and Urban Affairs, Government of India, the CoE is envisioned as a dynamic platform for collaboration between academia and governance. The website is designed as an open gateway for Central and State Governments, Urban Local Bodies (ULBs), and allied institutions to engage directly with SPA Delhi in addressing contemporary urban challenges.</p>
                    <p className='text-black'>Through this Centre, we invite all tiers of government to come forward and partner with us in developing live on-ground projects, undertaking specialized training programs, and conducting research-driven policy support. Whether the objective is urban regeneration, infrastructure planning, design innovation, or project implementation, SPA Delhi stands ready to offer cutting-edge expertise, backed by our legacy of academic excellence and professional integrity.</p>
                    <p className='text-black'>This platform reflects our belief that transformational change in the urban realm requires collaborative, interdisciplinary, and sustained action. I sincerely hope the CoE website becomes a conduit for impactful partnerships and a catalyst for innovation in India’s built environment.</p>
                    <p className='text-black'>Warm regards,</p>

                    <div className='text-black'>
                        Prof. Dr. V. K. Paul
                    </div>
                    <div className='text-black'>
                        Director
                        <p className='text-black'>School of Planning and Architecture, New Delhi</p>
                    </div>

                </div >
            </div >

        </section >
    );
};

export default ADirectorDesk;